import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {FirebaseMessageRoomItemPayload} from 'types'
import {getFontFamily, useHistory} from 'utils'
import {Paragraph, ParsedText} from 'common/components'

export interface GiftShopMessageRoomContentItemNotificationFollowRequestProps {
  payload: FirebaseMessageRoomItemPayload['notification_follow_request']
}

const StyledParagraph = styled(Paragraph)`
  white-space: pre-wrap;
`

export default function GiftShopMessageRoomContentItemNotificationFollowRequest({
  payload: {username, member_id},
}: GiftShopMessageRoomContentItemNotificationFollowRequestProps) {
  const {translate} = useTranslation()
  const history = useHistory()

  return (
    <StyledParagraph fontSize="m">
      <ParsedText
        parse={[
          {
            pattern: /<bold>.*?<\/bold>/,
            style: {
              fontFamily: getFontFamily('bold'),
              cursor: 'pointer',
            },
            renderText: (text) => text.replace(/<bold>|<\/bold>/g, ''),
            onClick: () =>
              history.push(
                'giftshop_profile',
                {
                  self: false,
                  postData: {
                    member_id,
                    username,
                  },
                },
                username,
              ),
          },
        ]}>
        {translate('messages:notificationFollowRequest', {
          username,
        })}
      </ParsedText>
    </StyledParagraph>
  )
}
